import { useState } from "react";
import { useMyDialog } from "../context/MyDialogProvider";

import MainOptionsStep from "./steps/MainOptionsStep";
import TransferStep from "./steps/TransferStep";
import PointsStep from "./steps/PointsStep";
import BmlGatewayStep from "./steps/BmlGatewayStep";
import CardStep from "./steps/CardStep";
import MobileStep from "./steps/MobileStep";

export type PayStep =
  | "main"
  | "transfer"
  | "points"
  | "bmlgateway"
  | "card"
  | "mobile";

interface Props {
  itemId?: number;
  amount?: number;
  order_id?: number;
}

export default function PayDialog({ itemId, amount=0 , order_id}: Props) {
  const { close } = useMyDialog();
  const [step, setStep] = useState<PayStep>("main");


  return (
    <div className="p-6 w-full max-w-md bg-white dark:bg-gray-900 rounded-2xl shadow-lg">
      {/* Header */}
      <div className="flex justify-between mb-6">
        <h2 className="text-xl font-semibold">
          {step === "main" && "Select a Payment Option"}
          {step === "points" && "Pay with Points"}
          {step === "card" && "Pay with Card"}
          {step === "mobile" && "Mobile Payment"}
          {step === "transfer" && "QR Transfer"}
          {step === "bmlgateway" && "BML Gateway"}
        </h2>

        <button onClick={close} className="text-xl">✕</button>
      </div>

      {/* Steps */}
      {step === "main" && <MainOptionsStep setStep={setStep} />}
      {step === "points" && <PointsStep itemId={itemId} onBack={() => setStep("main")} />}
      {step === "transfer" && <TransferStep amount={amount} onBack={() => setStep("main")} />}
      {step === "bmlgateway" && <BmlGatewayStep order_id={order_id} itemId={itemId} amount={amount} onBack={() => setStep("main")} />}
      {step === "card" && <CardStep amount={amount} onBack={() => setStep("main")} />}
      {step === "mobile" && <MobileStep onBack={() => setStep("main")} />}
    </div>
  );
}